import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';

@Injectable()
export class SessionFacade {
  constructor(private readonly store: Store<AppState>) {}
}
